import * as React from 'react';
import styled from 'styled-components';

const KartraSignupForm = () => (
    <>
        <h4>Sign up for our email list</h4>
        <Frame src="/kartra.html" width="100%" height="500" />
    </>
);

export default KartraSignupForm;

const Frame = styled.iframe`
    border: none;
`;
